import { IFilter, InitializeFilterDropdown } from "../../../shared/scripts/dropdown-functions";

import { plainToClass } from "class-transformer";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { WorkGroupEntity } from "./work-group.entities";
import { DocumentLibraryLoaderWithSharepoint } from "../../../shared/components/document-library/document-library-loader";



export class WorkingGroupsPage implements IFilter {

    users: WorkGroupEntity[];
    visibleUserEmails: string;
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    documentLibraryLoader: DocumentLibraryLoaderWithSharepoint;


    constructor(pageString: string, userJson: any, modelJson: any, isCollab: boolean, requiredDialogId: string = "", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {
            this.users = plainToClass(WorkGroupEntity, <WorkGroupEntity[]>userJson);
            this.users = this.users.map((user: WorkGroupEntity) => {
                user.initialize();
                return user;
            });

            if (pageString === "cde") this.users = this.users.filter((user: WorkGroupEntity) => user.CONNECT_Workgroup.includes("CDE Workgroup"));
            if (pageString === "dissemination") this.users = this.users.filter((user: WorkGroupEntity) => user.CONNECT_Workgroup.includes("Dissemination Workgroup"));
            if (pageString === "steering") this.users = this.users.filter((user: WorkGroupEntity) => user.CONNECT_Workgroup.includes("Steering Committee"));
            if (pageString === "science") this.users = this.users.filter((user: WorkGroupEntity) => user.CONNECT_Workgroup.includes("Implementation Science"));
            if (pageString === "cop") this.users = this.users.filter((user: WorkGroupEntity) => user.CONNECT_Workgroup.includes("Community of Practice"));

            this.documentLibraryLoader = new DocumentLibraryLoaderWithSharepoint(modelJson, isCollab, requiredDialogId, targetFile, targetSearchBox);

            //this.initializeFilters();
            //this.initializeExpandableContentWatcher();

            this.initializeTable();

            //triggers the redraw to account due to column with icon. will see a slight "popping" if looking carefully            
            setTimeout(() => {
                $("#user-directory-table").DataTable().columns.adjust().draw();
            }, 1);
        });
    }


    initializeTable(): void {
        this.dataTable = $('#user-directory-table').DataTable({
            "dom": '<"top-controls"<"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: [
                { data: { _: "DisplayEmail", sort: "Email" }, title: "Email", className: "email text-left font-size12" },
                { data: { _: "DisplayName", sort: "SortName" }, title: "Name", className: "name text-left font-size12" },
                { data: "Role", title: "Role", className: "role text-left font-size12" },
                { data: "ResearchHub", title: "CONNECT Affiliation", className: "affiliation text-left font-size12" },
                { data: "Institution", title: "Institution", className: "institution text-left font-size12" },
                //{ data: "ExpertisePastRoles", title: "<span class='nowrap'>Prior Research Role</span>", className: "research text-left font-size12" },
                //{ data: "ExpertiseAsud", title: "<span class='nowrap'>ASUD Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertisePsych", title: "<span class='nowrap'>Psychological Comorbidity Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertiseClinical", title: "<span class='nowrap'>Clinical Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertiseRegulatory", title: "<span class='nowrap'>Regulatory Expertise</span>", className: "specialized text-left font-size12" },
                //{ data: "ExpertiseDesign", title: "<span class='nowrap'>Study Design and Analysis Expertise</span>", className: "specialized text-left font-size12" },
                //{ data: "ExpertisePopulation", title: "<span class='nowrap'>Military and Veteran Populations Expertise</span>", className: "specialized text-left font-size12" },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                },
                {
                    text: '<i class="fas fa-envelope"></i>',
                    titleAttr: 'Send Email',
                    action: (e, dt, node, config) => {
                        //console.log(this.visibleUserEmails);

                        navigator.clipboard.writeText(this.visibleUserEmails).then(
                            () => {
                                $('#directory-email-modal').modal('show');
                                $('#modal-email-list').text(this.visibleUserEmails);
                            });
                    }
                }
            ],
            data: this.users,
            initComplete: (settings, json) => { }
        });

        $(".top-controls").addClass('row mx-0');

        //$(".column-select").addClass('col-12 col-md-3 px-0');
        //$(".column-select").empty().html('<div id="column-select" class="truncated-select"></div>');
        //$(".collapse-filters").empty().html('<button type="button" class="btn btn-sm btn-outline-secondary font-size11 collapse-button" id="collapse-button" onclick="page.toggleExpertiseSidebar()"><i class="fa-solid fa-arrow-left" id="arrow"></i></button>');

        $(".search-bar").addClass('col-12 col-md-3 pl-0');
        $(".spacer").addClass('col-12 col-md-3');
        $(".count-found").addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle align-self-end mt-2');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"people-found-count\"></span></div>');
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        //this.tableColumnController = new TableColumnVisibilityController('#user-directory-table', '#column-select', [
        //    new TableColumnGroup("Email", true, [], "email"),
        //    new TableColumnGroup("Name", false, [], "name"),
        //]);

        $('#user-directory-table').on('search.dt', (e, settings) => {
            this.createEmailList(this.dataTable.rows({ search: 'applied' }).data());
            this.setPeopleFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.createEmailList(this.users);
        this.setPeopleFoundLabel(this.users.length);
    }

    createEmailList(matchingUsers: WorkGroupEntity[]): void {
        this.visibleUserEmails = matchingUsers.map((user: WorkGroupEntity) => user.Email).join("; ");
        //console.log(this.visibleUserEmails);
    }

    setPeopleFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#people-found-count').text("Nobody Found"); break;
            case 1: $('#people-found-count').text("1 Person Found"); break;
            default: $('#people-found-count').text(count + " People Found");
        }
    }

    triggerFilter(): void {

        //let matchingUsers: UserDirectoryEntity[] = [];

        //let userMatches: boolean;
        //this.users.forEach((user: UserDirectoryEntity) => {

        //    userMatches = true; //must match all filters

        //    //this.filterDropdownIds = ['#pasarole-dropdown', '#institution-dropdown', '#study-dropdown', '#studytype-dropdown', '#pastrole-dropdown', '#asud-dropdown', '#psych-dropdown', '#clinical-dropdown', '#reg-dropdown', '#design-dropdown', '#pop-dropdown'];

        //    if (!user.matchesFilter(this.getSelectedDropdownValues('#pasarole-dropdown'), this.getSelectedDropdownValues('#institution-dropdown'), this.getSelectedDropdownValues('#study-dropdown'),
        //        this.getSelectedDropdownValues('#studytype-dropdown'), this.getSelectedDropdownValues('#pastrole-dropdown'), this.getSelectedDropdownValues('#asud-dropdown'),
        //        this.getSelectedDropdownValues('#psych-dropdown'), this.getSelectedDropdownValues('#clinical-dropdown'), this.getSelectedDropdownValues('#reg-dropdown'),
        //        this.getSelectedDropdownValues('#design-dropdown'), this.getSelectedDropdownValues('#pop-dropdown'))) {
        //        userMatches = false;
        //    }

        //    if (userMatches) { matchingUsers.push(user); }
        //});

        //this.updateTable(matchingUsers);
    }
}